import { getLocalTime } from '../time/time';

// Temporary extra access adds another role's permissions to a user's own role until a set time.
// Expiry is decided when access is checked, so nothing has to change the user back.
export const isExtraAccessActive = (extraAccess, now = new Date()) => Boolean(extraAccess?.role &&
	extraAccess.until &&
	!extraAccess.removedAt &&
	new Date(extraAccess.until) > now);

// Keeps the own role's id, name and settings so name based checks (driver, picker, admin) are unchanged.
export const addExtraRolePermissions = (role, extraRole) => ({
	...role,
	permissions: [...new Set([...(role?.permissions || []), ...(extraRole?.permissions || [])])],
});

// The signed-in user as clients use it: own role plus the permissions of active extra access.
export const withExtraAccessPermissions = (user, now = new Date()) => {
	if (!user?.role || !isExtraAccessActive(user.extraAccess, now)) {
		return user;
	}

	return {
		...user,
		role: addExtraRolePermissions(user.role, user.extraAccess.role),
	};
};

// e.g. "+ Warehouse until 11:59 pm"
export const formatExtraAccess = (extraAccess, timezone) => (
	`+ ${extraAccess.role?.name || 'Extra role'} until ${getLocalTime(timezone || undefined, extraAccess.until).format('h:mm a')}`
);
